module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-view schades",
    attrs: {
      "id": "pagingtop"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.totaalSchades.length == 0 || _vm.pageDataFailed) ? _c('div', {
    staticClass: "card-header"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.pageDataLoaded && !_vm.pageDataFailed) ? _c('loader-component') : _vm._e(), _vm._v(" "), (_vm.totaalSchades.length == 0 && _vm.pageDataLoaded) ? _c('div', {
    staticClass: "card-block"
  }, [_c('p', [_vm._v("U heeft nog geen schades gemeld.")])]) : _vm._e(), _vm._v(" "), (_vm.pageDataFailed) ? _c('div', {
    staticClass: "card-block",
    attrs: {
      "id": "error-mijnschades"
    }
  }, [_c('p', [_vm._v("Wij hebben geen schades kunnen vinden.")])]) : _vm._e(), _vm._v(" "), (_vm.pageDataLoaded) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.chunkedArray[_vm.currentPage]), function(schade) {
    return _c('tbody', {
      key: schade.schadenummer
    }, [_c('tr', {
      staticClass: "main",
      class: {
        open: schade.isOpen
      },
      on: {
        "click": function($event) {
          schade.isOpen = !schade.isOpen
        }
      }
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v(_vm._s(schade.schadedatum))]), _vm._v(" "), _c('td', {
      staticClass: "damage-num"
    }, [_vm._v(_vm._s(schade.schadenummer))]), _vm._v(" "), _c('td', {
      staticClass: "insurance"
    }, [_vm._v("\r\n\t\t\t\t\t" + _vm._s(schade.produktNaam) + "\r\n\t\t\t\t\t"), (schade.kenteken) ? _c('span', [_vm._v(" | " + _vm._s(schade.kenteken))]) : _vm._e(), _vm._v(" "), (schade.produktTypeNaam == 'woonhuis' || schade.produktTypeNaam == 'inboedel') ? _c('span', [_vm._v(" | " + _vm._s(schade.straat))]) : _vm._e()]), _c('td', {
      staticClass: "damage-type"
    }, [_vm._v(_vm._s(schade.schadesoort))]), _vm._v(" "), _c('td', {
      staticClass: "status"
    }, [_c('span', {
      directives: [{
        name: "if!",
        rawName: "v-if!",
        value: (null),
        expression: "null"
      }],
      class: [{
        'tag': schade.schadestatus == 'afgehandeld'
      }, {
        'tag tag-danger': schade.schadestatus == 'wacht op uw reactie'
      }, {
        'tag tag-success': schade.schadestatus == 'in behandeling'
      }, {
        'tag tag-success': schade.schadestatus == 'beoordeling'
      }, {
        'tag tag-success': schade.schadestatus == 'ontvangen'
      }]
    }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(schade.schadestatus) + "\r\n\t\t\t\t\t")])])]), _vm._v(" "), _c('tr', {
      staticClass: "details",
      class: {
        open: schade.isOpen
      }
    }, [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', [_c('span', {
      staticClass: "icon clean",
      on: {
        "click": function($event) {
          schade.isOpen = !schade.isOpen
        }
      }
    }, [_vm._v("0")]), _vm._v(" "), _c('p', {
      staticClass: "tag",
      class: [{
        'tag-danger': schade.schadestatus == 'wacht op uw reactie'
      }, {
        'tag-success': schade.schadestatus == 'in behandeling'
      }, {
        'tag-success': schade.schadestatus == 'beoordeling'
      }, {
        'tag-success': schade.schadestatus == 'ontvangen'
      }]
    }, [_vm._v(_vm._s(schade.schadestatus))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (schade.isOpen),
        expression: "schade.isOpen"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-mo-6 col-xs-12"
    }, [_c('label', [_vm._v("Soort schade")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(schade.schadesoort))])]), _vm._v(" "), _c('div', {
      staticClass: "col-mo-6 col-xs-12"
    }, [(schade.kenteken) ? _c('label', [_vm._v("Kenteken")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(schade.kenteken))]), _vm._v(" "), (schade.produktTypeNaam == 'woonhuis' || schade.produktTypeNaam == 'inboedel') ? _c('label', [_vm._v("Adres")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(schade.straat))])])])])])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('nav', {
    staticClass: "paging"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item"
  }, [(_vm.currentPage > 0) ? _c('button', {
    staticClass: "previous btn btn-secondary",
    attrs: {
      "data-href": "#pagingtop",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentPage -= 1
      }
    }
  }, [_vm._v("Vorige")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.totalPages), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      staticClass: "page-item"
    }, [_c('button', {
      staticClass: "btn btn-secondary",
      class: {
        active: pageNumber === _vm.currentPage + 1
      },
      attrs: {
        "data-href": "#pagingtop",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.currentPage = pageNumber - 1
        }
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item"
  }, [(_vm.currentPage < _vm.totalPages - 1) ? _c('button', {
    staticClass: "next btn btn-secondary",
    attrs: {
      "data-href": "#pagingtop",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentPage += 1
      }
    }
  }, [_vm._v("Volgende")]) : _vm._e()])], 2)]) : _vm._e(), _vm._v(" "), (_vm.pageDataLoaded) ? _c('p', {
    staticClass: "aantalfacturen"
  }, [(_vm.totaalSchades == 1) ? _c('span', [_c('strong', [_vm._v("1")]), _vm._v(" schade gevonden")]) : _c('span', [_c('strong', [_vm._v(_vm._s(_vm.totaalSchades))]), _vm._v(" schades gevonden")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("Mijn schades")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "date"
  }, [_vm._v("Datum")]), _vm._v(" "), _c('th', {
    staticClass: "damage-num"
  }, [_vm._v("Schadenr.")]), _vm._v(" "), _c('th', {
    staticClass: "insurance"
  }, [_vm._v("Verzekering")]), _vm._v(" "), _c('th', {
    staticClass: "damage-type"
  }, [_vm._v("Soort schade")]), _vm._v(" "), _c('th', {
    staticClass: "status"
  }, [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3660cc78"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/schade/mijnschades.vue
// module id = 106
// module chunks = 0